import React, { useEffect, useState } from 'react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { toast } from 'sonner';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const ClientTeamManagement = ({ user }) => {
  const [members, setMembers] = useState([]);
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({ name: '', email: '', password: '', corporate_role: 'gestor' });

  const headers = () => ({
    Authorization: `Bearer ${localStorage.getItem('session_token')}`,
    'Content-Type': 'application/json',
  });

  const load = async () => {
    const res = await fetch(`${BACKEND_URL}/api/client-invoicing/client/team`, { headers: headers() });
    if (res.ok) {
      const data = await res.json();
      setMembers(data.members || []);
    }
  };

  useEffect(() => {
    if (user?.multi_user_enabled && (user?.corporate_role || 'manager') === 'manager') {
      load();
    }
  }, [user]);

  if (!user?.multi_user_enabled || (user?.corporate_role || 'manager') !== 'manager') {
    return null;
  }

  const invite = async (e) => {
    e.preventDefault();
    const res = await fetch(`${BACKEND_URL}/api/client-invoicing/client/team`, {
      method: 'POST',
      headers: headers(),
      body: JSON.stringify(form),
    });
    if (res.ok) {
      toast.success('Usuario invitado');
      setOpen(false);
      setForm({ name: '', email: '', password: '', corporate_role: 'gestor' });
      load();
    } else {
      const err = await res.json().catch(() => ({}));
      toast.error(err.detail || 'Error al invitar');
    }
  };

  const revoke = async (id) => {
    if (!window.confirm('¿Revocar acceso?')) return;
    const res = await fetch(`${BACKEND_URL}/api/client-invoicing/client/team/${id}`, {
      method: 'DELETE',
      headers: headers(),
    });
    if (res.ok) {
      toast.success('Acceso revocado');
      load();
    }
  };

  return (
    <div className="space-y-4">
      <div className="flex justify-between items-center">
        <h2 className="text-xl font-bold">Gestión de equipo</h2>
        <Button onClick={() => setOpen(true)}>Invitar usuario</Button>
      </div>
      <div className="border rounded-lg divide-y">
        {members.filter((m) => m.id !== user.id).map((m) => (
          <div key={m.id} className="p-3 flex justify-between items-center">
            <div>
              <p className="font-medium">{m.name}</p>
              <p className="text-sm text-gray-500">{m.email} — {m.corporate_role}</p>
            </div>
            {m.corporate_role !== 'manager' && (
              <Button variant="outline" size="sm" onClick={() => revoke(m.id)}>
                Revocar
              </Button>
            )}
          </div>
        ))}
        {members.length <= 1 && <p className="p-4 text-gray-500 text-sm">No hay usuarios secundarios.</p>}
      </div>

      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent>
          <DialogHeader>
            <DialogTitle>Invitar miembro del equipo</DialogTitle>
          </DialogHeader>
          <form onSubmit={invite} className="space-y-3">
            <div>
              <Label>Nombre</Label>
              <Input value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} required />
            </div>
            <div>
              <Label>Email</Label>
              <Input type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} required />
            </div>
            <div>
              <Label>Contraseña temporal</Label>
              <Input type="password" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} required />
            </div>
            <div>
              <Label>Rol</Label>
              <select
                className="w-full border rounded-md px-3 py-2"
                value={form.corporate_role}
                onChange={(e) => setForm({ ...form, corporate_role: e.target.value })}
              >
                <option value="gestor">Gestor (solo sus servicios)</option>
                <option value="admin">Admin (operaciones, sin facturación)</option>
              </select>
            </div>
            <Button type="submit" className="w-full">Invitar</Button>
          </form>
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default ClientTeamManagement;
